//GALEASSO FEDERICO 4C - SPOTIFY SEARCHER

import './App.css';
import logoSpotify from './logoSpotify.png';
import logoFede from './logoFede.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, InputGroup, FormControl, Row, Card, Navbar} from 'react-bootstrap';
import  {useState, useEffect} from 'react';
import { MDBFooter } from 'mdb-react-ui-kit';

//Spotify Dashboard: developer.spotify.com
const CLIENT_ID = "9bb25e3de0c44efbb1cb2ba1eae83788";
const CLIENT_SECRET = "93889b8a990c4fe6be80a05860694ec3";

function App() {
  const [ricerca, setRicerca] = useState("");
  const [click, setClick] = useState("");
  const [nomeArtistaAlbum, setNomeArtistaAlbum] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [profilo, setProfilo] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [tracks, setTracks] = useState([]);

  useEffect(() => {
    //API Access Token
    let parametri_autenticazione={
      method:"POST",
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body:'grant_type=client_credentials&client_id=' + CLIENT_ID + '&client_secret=' + CLIENT_SECRET
    }
    fetch('https://accounts.spotify.com/api/token', parametri_autenticazione)
      .then(result => result.json())
      .then(data => setAccessToken(data.access_token))
  }, [])

  //Funzione per ricercare un artista e stampare il suo profilo e i suoi album
  async function ricercaArtista(){
    console.log("Ricerca dell'utente: " + ricerca)

    //Richiesta per ottenere l'ID dell'artista
    let parametri_ricerca={
      method:'GET',
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accessToken
      }
    }

    let artistID=await fetch('https://api.spotify.com/v1/search?q=' + ricerca + '&type=artist' , parametri_ricerca)
      .then(response => response.json())
      .then(data => {return data.artists.items[0].id})

    console.log("Artist ID: " + artistID)

    //Richiesta per ottenere tutti gli album dell'artista cercato
    await fetch('https://api.spotify.com/v1/artists/' + artistID + '/albums' + '?include_groups=album&market=US&limit=50', parametri_ricerca)
      .then(response => response.json())
      .then(data => {
        console.log("ALBUM:")
        console.log(data.items)
        setAlbums(data.items)
      })

    //Richiesta per ottenere il profilo dell'artista
    await fetch('https://api.spotify.com/v1/search?q=' + ricerca + '&type=artist' , parametri_ricerca)
    .then(response => response.json())
    .then(data => {
      console.log("PROFILO:")
      console.log(data.artists.items[0])
      setProfilo(data.artists.items[0])
    })
  }

  //Funzione per visualizzare le canzoni dell'album cliccato
  async function stampaCanzoni(nomeAlbum, nomeArtistaAlbum){
    //Richiesta per ottenere l'ID dell'album
    let parametri_ricerca={
      method:'GET',
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accessToken
      }
    }

    setClick(nomeAlbum)
    setNomeArtistaAlbum(nomeArtistaAlbum)

    console.log("Nome dell'album cliccato: " + nomeAlbum)
    console.log("Nome dell'artista dell'album: " + nomeArtistaAlbum)

    let albumID=await fetch('https://api.spotify.com/v1/search?q=' + click + '&type=album' , parametri_ricerca)
      .then(response => response.json())
      .then(data => {return data.albums.items[0].id})

    console.log("Album ID: " + albumID)

    //Richiesta per ottenere tutti i brani dell'album cliccato
    await fetch('https://api.spotify.com/v1/albums/' + albumID + '/tracks' + '?include_groups=track&market=US&limit=50', parametri_ricerca)
      .then(response => response.json())
      .then(data => {
        console.log("BRANI:")
        console.log(data.items)
        setTracks(data.items)
      })
  }

  return (
    <div className="App">
      <Navbar bg="dark" variant="dark" className="mb-5 navbar">
        <Container className="d-flex justify-content-center p-1">
          <Navbar.Brand>
            <img src={logoSpotify} width="40vh" className="d-inline align-top justify-content-center"/>{' '}
            Spotify Searcher
          </Navbar.Brand>
        </Container>
      </Navbar>

      <Container>
        <Row className="mt-3"><h1><strong>Benvenuto!</strong></h1></Row>
        <Row className="mb-2"><h5>Inserisci il nome di un artista per visualizzare il suo profilo e i suoi album.<br/>In seguito, potrai cliccare su un album per visualizzare le sue canzoni.</h5></Row>
        <Row className="mb-5 rowBy"><i>by Federico Galeasso</i></Row>
        <InputGroup className="mb-5">
          <FormControl placeholder="Inserisci il nome di un artista" type="input" onChange={event => setRicerca(event.target.value)}/>
          <button onClick={ricercaArtista} className="button">
            CERCA
          </button>
        </InputGroup>
      </Container>

      <Container>

        {/* Visualizzazione del profilo dell'artista cercato */}
        <h5 className="mt-5">Profilo dell'artista</h5>
        Nome: {profilo.name}

        <h5 className="mt-5 mb-3">Album di <b>{profilo.name}</b></h5>
        <Row className="mx-2 row row-cols-sm-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
          {/* Visualizzazione degli album */}
          {albums.map((album, i) => {
            return(
              <Card className="card">
                <Card.Img src={album.images[0].url}/>
                <Card.Body>
                  <Card.Title><b>{album.name}</b></Card.Title>
                  <Card.Subtitle>{album.artists[0].name}</Card.Subtitle>
                  <button onClick={()=>stampaCanzoni(album.name, album.artists[0].name)} className="mt-4 button">
                    ALTRO
                  </button>
                </Card.Body>
              </Card>
            )
          })}
        </Row>

        {/* Visualizzazione dei brani dell'album cliccato */}
        <h5 className="mt-5 mb-3">Brani dell'album <b>{click}</b>, di <b>{nomeArtistaAlbum}</b></h5>
        <Row className="mx-2 row row-cols-sm-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
          {tracks.map((track, i) => {
            return(
              <Card className="card">
                <Card.Body>
                  <Card.Title><b>{track.name}</b></Card.Title>
                  <a href={track.external_urls.spotify} target="blank">
                    <button className="button">Ascolta ora</button>
                  </a>
                </Card.Body>
              </Card>
            )
          })}
        </Row>
      </Container>

      <MDBFooter bgColor='dark' className='mt-5 footer' color="white">
        <div className='p-3 d-flex justify-content-center align-items-center'>
          <img src={logoFede} width="40vh" className="d-inline align-top justify-content-center logoFooter"/>
          © 2023 Federico Galeasso. All rights reserved.
        </div>
      </MDBFooter>
    </div>
  );
}

export default App;